$(document).ready(function () {
    /**
    * Execute a function given a delay time
    *
    * @param {type} func
    * @param {type} wait
    * @param {type} immediate
    * @returns {Function}
    */
    var debounce = function (func, wait, immediate) {
        var timeout;
        return function() {
            var context = this, args = arguments;
            var later = function() {
                    timeout = null;
                    if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
   };
    //// GIFT CARD CUSTOMIZE
    var textSelect = $('.property_giftcard select option').filter(':selected').val();
    if (textSelect !== 'Please select' ){
        jQuery('.product_gift_card .product_price-default').addClass('not-select');
        jQuery('.product_gift_card .product_price-default').show();
        jQuery('.product_gift_card .product__price.min').hide();
        jQuery('.btn.addto-cart,.btn_cart_custom,.btn_cart_custom_physical,.btn_cart_physical').prop('disabled', false);
    }else{
        jQuery('.product_gift_card .product_price-default').removeClass('not-select');
        jQuery('.product_gift_card .product_price-default').hide();
        jQuery('.product_gift_card .product__price.min').show();
        jQuery('.btn.addto-cart,.btn_cart_custom,.btn_cart_custom_physical,.btn_cart_physical').prop('disabled', true);
    }

    $('.property_giftcard select').on('change', function() {
        var text = $('.btn_cart_custom > span,.btn_cart_custom_physical > span').html();
        var textSelect = $('.property_giftcard select option').filter(':selected').val();
        if (textSelect !== 'Please select' ){
            jQuery('.product_gift_card .product_price-default').addClass('not-select');
            jQuery('.product_gift_card .product_price-default').show();
            jQuery('.product_gift_card .price-min').hide();
            jQuery('.btn.addto-cart,.btn_cart_custom,.btn_cart_custom_physical,.btn_cart_physical').prop('disabled', false);
        }else{
            jQuery('.product_gift_card .product_price-default').removeClass('not-select');
            jQuery('.product_gift_card .product_price-default').hide();
            jQuery('.product_gift_card .price-min').show();
            jQuery('.btn.addto-cart,.btn_cart_custom,.btn_cart_custom_physical,.btn_cart_physical').prop('disabled', true);
        }
        jQuery('.btn.addto-cart .btn__text,.btn_cart_physical .btn__text').text(text);
        if (text == 'Sold out' || text == 'Unavailable' ){
            jQuery('.btn.addto-cart,.btn_cart_custom,.btn_cart_custom_physical,.btn_cart_physical').prop('disabled', true);
            jQuery('.btn.addto-cart .btn__text,.btn_cart_physical .btn__text').text('Sold out');
        }
    });

    jQuery('.btn.addto-cart').click(function(e) {
        e.preventDefault();
        $('.gift_card_form').valid();
        const $senderSelect = jQuery('#sender-email')
        const $recipientSelect = jQuery('#recipient-email')
        var senderEmail = $senderSelect.val()
        var recipientEmail = $recipientSelect.val()

        var senderName = jQuery('#sender-name').val();
        var recipientName = jQuery('#recipient-name').val();
        var Message = jQuery('#message').val();
        var elementInput = jQuery('.property_form input');

        if(senderEmail) validateEmail($senderSelect)
        if(recipientEmail) validateEmail(($recipientSelect))

        if (senderEmail && senderName && recipientEmail && recipientName && Message){
            if (!elementInput.hasClass('error')){
                $('.btn_cart_custom').trigger('click');
                $('.addto-cart .loading').removeClass('hide');
                $(this).addClass('active');
            }
        }
    });


    const validateEmail = ($input) => {
        const email = $input.val()
        // Regular expression for validating email addresses
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        if(!emailRegex.test(email)){
            showError($input)
        }
    }

    const showError = ($el) => {
        const id = $el.attr('id')
        $el.addClass('error')

        const error = `<label id="${id}-error" class="error" for="${id}">Invalid Email</label>`
        $(error).insertAfter($el)
    }

    jQuery('.btn_cart_physical ').click(function(e) {
        e.preventDefault();
        $('.product-physical-form').valid();
        var recipientMessage = jQuery('#message').val();
        var elementTextarea = jQuery('.property_form textarea');
        if (recipientMessage){
            if (!elementTextarea.hasClass('error')){
                $('.btn_cart_custom_physical').trigger('click');
                $('.btn_cart_physical .loading').removeClass('hide');
                $(this).addClass('active');
            }
        }
    });

    setInterval(function (){
        jQuery('.btn.addto-cart,.btn_cart_physical').removeClass('active');
        $('.addto-cart .loading,.btn_cart_physical .loading').addClass('hide');
    },3000);

    // END GIFT CARD


    jQuery('.newsletter__submit').click(function(e) {
        $(".contact-form").submit(function(e){
            e.preventDefault();
        });
        var val = jQuery('.newsletter__input').val();
        var element = jQuery('.newsletter__input');
        localStorage.removeItem("popState");
        if (val){
            if (!element.hasClass('error')){
                if (localStorage.getItem('popState') != 'show') {
                    localStorage.setItem('popState', val);
                }
                var urlRediect = jQuery('.redirect-login').attr('href');
                window.location.replace(urlRediect);
            }
        }
    });


    if (localStorage.getItem('popState')) {
        var value = localStorage.getItem('popState');
        jQuery('.input-email-register input').val(value);
    }

    jQuery("#ContactFooter , .gift_card_form , .form_voucher_code").validate({
        // use highlight and unhighlight
        highlight: function (element, errorClass, validClass) {
            jQuery(element.form).find("label[for=" + element.id + "]").addClass("error-label");
            if (element.type === "radio") {
                this.findByName(element.name).addClass(errorClass).removeClass(validClass);
            } else {
                jQuery(element).addClass(errorClass).removeClass(validClass);
            }
        },
        unhighlight: function (element, errorClass, validClass) {
            jQuery(element.form).find("label[for=" + element.id + "]").removeClass("error-label");
            if (element.type === "radio") {
                this.findByName(element.name).removeClass(errorClass).addClass(validClass);
            } else {
                jQuery(element).removeClass(errorClass).addClass(validClass);
            }
        }
    });

    jQuery("#customer_login , .contact-form").validate({
        // use highlight and unhighlight
        highlight: function (element, errorClass, validClass) {
            jQuery(element.form).find("label[for=" + element.id + "]").addClass("error-label");
            if (element.type === "radio") {
                this.findByName(element.name).addClass(errorClass).removeClass(validClass);
            } else {
                jQuery(element).addClass(errorClass).removeClass(validClass);
            }
        },
        unhighlight: function (element, errorClass, validClass) {
            jQuery(element.form).find("label[for=" + element.id + "]").removeClass("error-label");
            if (element.type === "radio") {
                this.findByName(element.name).removeClass(errorClass).addClass(validClass);
            } else {
                jQuery(element).removeClass(errorClass).addClass(validClass);
            }
        }
    });

    // FHSD-215 custom validation must be applied after other validate invocations to prevent race condition for validator
    if ($('#sender-name,#recipient-name').length) {
        $.validator.addMethod('noEmailInName', function (value) {
            // reject any string containing an @
            return /^((?!@).)*$/.test(value);
        }, 'Do not enter an email for name.');

        $('#sender-name').rules('add', 'noEmailInName')
        $('#recipient-name').rules('add', 'noEmailInName')
    }

    jQuery(document).on('click','.ex_title i',function(e){
        e.preventDefault();
        jQuery('.expadding_content').slideToggle();
        jQuery(this).closest('.ex_title').toggleClass('ex_open');
    });
    if (document.querySelector('.fh-slideshow')) {
        $('.fh-owl-slide').owlCarousel({
            loop: slideLoopEnable || false,
            margin:0,
            nav:true,
            dots: true,
            autoplay: slideLoopEnable || false,
            autoplayTimeout: slideDuration || 0,
            autoplayHoverPause: true,
            navText: ["<i class='far fa-chevron-left'></i>", "<i class='far fa-chevron-right'></i>"],
            responsive:{
                0:{
                    items:1
                },
                600:{
                    items:1
                },
                1000:{
                    items:1
                }
            }
        });
    }
    // show-dropdown
    $('.account-links--select').click(function () {
        $('.account-links__right').toggleClass('show-dropdown');
    });
    $('*').click(function (e) {
        if ($(e.target).attr('class') != 'account-links--select')
        $('.account-links__right').removeClass('show-dropdown');
    });
    //
    $('.card-heading').on('click', function () {
        if ($(this).parents('.accordian-card').hasClass('open')) {
            $(this).parents('.accordian-card').find('.card-body').slideUp();
            $(this).parents('.accordian-card').removeClass('open');
        }
        else {
            $(this).parents('.accordian').find('.card-body').slideUp();
            $(this).parents('.accordian').find('.accordian-card').removeClass('open');

            $(this).parents('.accordian-card').find('.card-body').slideDown();
            $(this).parents('.accordian-card').addClass('open');
        }
    });


    // Custom Js for choose variant product grid item
    //setTimeout(function(){
        jQuery('.variant_wrapper').addClass('active');
        jQuery('.variant_wrapper > .variant-item').on('click', function(e) {
            e.preventDefault();
            if (jQuery(this).hasClass('active')){
                return true;
            } else {
                // if (jQuery(this).data('action') == 0){
                //     return true;
                // }
                let itemId = jQuery(this).data('id');
                //console.log(itemId);
                let data_hanlde = jQuery(this).data('product-handle');
                let data_img_url = '';
                let data_price = '';
                let data_product_title = '';
                let data_product_url = '';
                let is_new = false;
                let is_preorder = false;
                jQuery(this).siblings('.variant-item').removeClass('active');
                jQuery(this).addClass('active');
                jQuery.getJSON('/products/'+data_hanlde+'.js', function(product) {
                    if(product.images[1]){
                        data_img_url = '<img class="grid-view-item__image feature_image" src="'+product.featured_image+'" ><img class="grid-view-item__image hover_image" src="'+product.images[1]+'" >';
                    }
                    else{
                        if(product.featured_image != null){
                            data_img_url = '<img class="grid-view-item__image feature_image" src="'+product.featured_image+'" ><img class="grid-view-item__image hover_image" src="'+product.featured_image+'" >';
                        }
                    }
                    data_product_title = product.title;
                    data_product_url = product.url;
                    let is_sale = product.compare_at_price_min > product.price_min;
                    //console.log(product);
                    if(product.tags.indexOf("NEWARRIVALS") > -1 || product.tags.indexOf("NEWARRIVAL") > -1){
                        is_new = true;
                    }
                    if(product.tags.indexOf("W-PREORDER") > -1){
                        is_preorder = true;
                    }
                    if(!product.available){
                        data_price += '<div class="price price--listing price--sold-out">';
                        data_price += '<span class="price-item price-item--regular">Sold out</span>';
                        data_price += '</div>';
                    }else{
                        if(product.compare_at_price_min > product.price_min){
                            data_price += '<div class="price price--listing price--on-sale">';
                            data_price += '<span class="price-item price-item--regular">'+Shopify.formatMoney(product.compare_at_price_min)+'</span>';
                            data_price += '<span class="price-item price-item--sale">'+Shopify.formatMoney(product.price)+'</span>';
                            data_price += '</div>';
                        }else{
                            data_price += '<div class="price price--listing">';
                            data_price += '<span class="price-item price-item--regular">'+Shopify.formatMoney(product.price)+'</span>';
                            data_price += '</div>';
                        }
                    }

                    //update product image
                    if(data_img_url != ''){
                        jQuery('.grid').find('#ProductCardImageWrapper-'+itemId).children('img').remove('img.grid-view-item__image').prepend(data_img_url);
                        jQuery('.grid').find('#ProductCardImageWrapper-'+itemId).prepend(data_img_url);
                    }

                    //update price
                    jQuery('.grid').find('.grid__item[data-id="'+itemId+'"]').find('.product-price').html(data_price);

                    // update label
                    jQuery('.grid').find('.grid__item[data-id="'+itemId+'"]').find('.product-label>span').removeClass('show').addClass('hide');
                    if (is_sale) {
                        jQuery('.grid').find('.grid__item[data-id="'+itemId+'"]').find('.label-sale').addClass('show').removeClass('hide');
                        is_preorder = false;
                        is_new = false;
                    } else if (is_preorder) {
                        jQuery('.grid').find('.grid__item[data-id="'+itemId+'"]').find('.label-preorder').addClass('show').removeClass('hide');
                        is_new = false;
                    } else if (is_new) {
                        jQuery('.grid').find('.grid__item[data-id="'+itemId+'"]').find('.label-new').addClass('show').removeClass('hide');
                    }

                    // update title
                    if(data_product_title){
                        jQuery('.grid').find('.grid__item[data-id="'+itemId+'"]').find('.product-card__title h4').text(data_product_title);
                    }

                    // update url
                    if(data_product_url){
                        // console.log(jQuery('.grid').find('.grid__item[data-id="'+itemId+'"]').find('a.product-card__title'));
                        //  console.log(jQuery('.grid').find('.grid__item[data-id="'+itemId+'"]').find('a.featured_image'));
                        jQuery('.grid').find('.grid__item[data-id="'+itemId+'"]').find('a.featured_image').attr('href', data_product_url);
                        jQuery('.grid').find('.grid__item[data-id="'+itemId+'"]').find('a.product-card__title').attr('href', data_product_url);
                    }
                });

            }
        });

        function catalogueUpdateOption() {
            jQuery('.fh-product__form-option .product-color-swatches__list > .product-color-swatches__item .product-color-swatches__item-link').bind('click', function(e) {
                e.preventDefault();
                if (jQuery(this).parent().hasClass('product-color-swatches__item--current')){
                    return true;
                } else {
                    let oldItemId = jQuery(this).data('id');
                    let data_hanlde = jQuery(this).data('product-handle');
                    let data_img_url = '';
                    let data_product_url = '';
                    jQuery(this).parent().siblings('.product-color-swatches__item ').removeClass('product-color-swatches__item--current');
                    jQuery(this).parent().addClass('product-color-swatches__item--current');
                    // jQuery.getJSON('/products/'+data_hanlde+'.js', function(product) {
                    //     console.log(product);
                    //     if(product.featured_image != null){
                    //         data_img_url = '<img class="lazyload" src="'+product.featured_image+'">';
                    //     }
                    //     //update product image
                    //     if(data_img_url != ''){
                    //         jQuery('.fh_catalog_right').find('#ProductCardImageWrapper-'+itemId).find('img').remove();
                    //         jQuery('.fh_catalog_right').find('#ProductCardImageWrapper-'+itemId+' .hover-change-img').append(data_img_url);
                    //     }
                    //     data_product_url = product.url;

                    //      // update url
                    //     if(data_product_url != ''){
                    //         jQuery('.fh_catalog_right').find('#ProductCardImageWrapper-'+itemId).find('a').attr('href', data_product_url);
                    //     }
                    // });
                    $.ajax({
                        method: "GET",
                        url: "/products/"+ data_hanlde,
                        data: {"view": "catalogue"},
                        async: true,
                        xhrFields: {
                            withCredentials: true
                        },
                        dataType: 'html',
                        success: function(response) {
                            //console.log(response);
                            let tmpHtml = $('<div></div>').append(response);
                            let formHtml = $(tmpHtml).find('.catalog_content_right').html();
                            let itemId = $(tmpHtml).find('.fh-product__form-option.product-form-product-template').data('id');
                            if(formHtml != ''){
                                jQuery('.fh_catalog_right').find('.catalog_content_right[data-id="'+oldItemId+'"]').data('id', itemId);
                                jQuery('.fh_catalog_right').find('.catalog_content_right[data-id="'+oldItemId+'"]').attr('data-id', itemId);
                                jQuery('.fh_catalog_right').find('.catalog_content_right[data-id="'+itemId+'"]').html(formHtml);
                            }
                            selectOptions();
                            selectonLoad();
                            jQuery('.fh-product__form-option .product-color-swatches__list > .product-color-swatches__item .product-color-swatches__item-link').unbind('click');
                            catalogueUpdateOption();
                            //jQuery('.fh_catalog_right').find('.catalog_content_right[data-id="'+itemId+'"]').html(response);
                            // if(productImage != ''){
                            //     jQuery('.fh_catalog_right').find('#ProductCardImageWrapper-'+itemId+' .hover-change-img').html(productImage);
                            // }
                        }
                        });
                }
            });
        };
        catalogueUpdateOption();

    // }, 3000);

    // Slide Healthwaer
    $('.healthwear-page .block-bottom .owl-carousel').owlCarousel({
        margin: 35,
        loop: true,
        autoWidth: true,
        items: 5,
        responsive:{
            0:{
              	items: 3,
                margin: 12
            },
            600:{
                margin: 12
            }
        }
    });
    // Slide New Arrivals Healthwear
    $('.healthwear-page .new-arrival .owl-carousel').owlCarousel({
        loop: false,
        margin: 29,
        dots: false,
        nav: false,
        responsive:{
            0:{
                items:2,
                margin: 12,
                dots: true
            },
            600:{
                items:3
            },
            991: {
                items: 3
            },
            1000:{
                items:4
            }
        }
    });

    // Dropdown in Category Filter
    $(".boost-pfs-filter-left .sidebar-content .sidebar-menu li .sidebar-link-parent-title").click(function(){
        $(this).parent().toggleClass('active');
    });
    if($(".boost-pfs-filter-left .sidebar-content .sidebar-menu li .sidebar-menu-child-item li a").hasClass('active')){
        $('.sidebar-link.active').closest(".sidebar-menu-child-item").parent().addClass('active');
    }
    // Dropdown in Category Filter

    // SEACH
    $('.site-header__search-icon').on('click', function(e) {
        e.preventDefault();
        $( ".site_search_container" ).addClass('active');
        $('.site_search_container.active .search-bar .search-bar__input').focus();
    });

    function screenWidth (){
        var $window = $(window);
        var windowsize = $window.width();
        jQuery('.cd-auto-hide-header').css('max-width',windowsize);
    }
    function setHeaderHeight (){
        var $windowHeight = $('.cd-auto-hide-header');
        var wHeight = $windowHeight.height();
        jQuery('.banner-navigation').css('padding-top', wHeight);
        jQuery('.padding_header').css('--top-height', wHeight +'px');
    }
    setHeaderHeight();
    screenWidth();
    $( window ).resize(function() {
        screenWidth();
        if (setHeaderHeight) {
            setHeaderHeight();
        }
    });

    $(document).on('click', function(e) {
        var container = $('.site_search_container');
        var container2 = $('.boost-pfs-search-suggestion-wrapper');
        if (!container.is(e.target) && container.has(e.target).length === 0 && !container2.is(e.target) && container2.has(e.target).length === 0) {
          $('.site_search_container').removeClass('active');
        }
    });

    if ($(window).width() < 768) {
        $('.site-header__search-icon').on('click', function(e) {
            $( ".boost-pfs-search-suggestion-mobile-top-panel" ).addClass('active').show();
            $('html').addClass('boost-pfs-search-suggestion-mobile-open');
        });
        // jQuery('.boost-pfs-search-btn-close-suggestion').on('click', function(e) {
        //     $( ".boost-pfs-search-suggestion-mobile-top-panel" ).removeClass('active');
        //     $('html').removeClass('boost-pfs-search-suggestion-mobile-open');
        // });
    }

    $(document).on('click', function(e) {
        var container = $('.site-header__search-icon');
        var container2 = $('.boost-pfs-search-suggestion-mobile-top-panel , .boost-pfs-search-suggestion-wrapper');
        if (!container.is(e.target) && container.has(e.target).length === 0 && !container2.is(e.target) && container2.has(e.target).length === 0) {
          $('.boost-pfs-search-suggestion-mobile-top-panel').removeClass('active');
          $('html').removeClass('boost-pfs-search-suggestion-mobile-open');
        }
        var $close =  jQuery('.boost-pfs-search-btn-close-suggestion');
        $close.off('click');
        $close.click(function () {
            $('.boost-pfs-search-suggestion-mobile-top-panel').removeClass('active');
            $('html').removeClass('boost-pfs-search-suggestion-mobile-open');
        });
    });
    // END SEARCH


    // Toan Custom
    // Set page cart
    if ($('.cart-related .product-recommendations__inner .grid--view-items').length) {
        // $('.cart-related .product-recommendations__inner .grid--view-items').addClass("owl-carousel owl-theme");
        $('.cart-related .product-recommendations__inner .grid--view-items').owlCarousel({
            loop:true,
            margin:30,
            nav: false,
            dots: true,
            responsive:{
                0:{
                    items:2,
                    dots: true,
                    margin: 12,
                    nav: true
                },
                768: {
                    dots: false,
                    margin: 30,
                    items: 4
                },
                1000:{
                    items:4
                }
            }
        });
    }

    /* MINICART FUNCTIONS */
    function refreshMiniCart(lineitem, quantity) {
        if ($('body').hasClass('template-cart')) {
            window.location.reload();
        } else {
            $.ajax({
            method: "GET",
            url: "/cart?view=ajax",
            dataType: 'html',
            success: function(response) {
                var CartCount = $(response).find('.minicart-items').attr('data-total');
                if (response) {
                    $('.mini-cart-wrapper').html(response);
                }
                if(CartCount){
                    $('.cartCount').text(CartCount);
                }
            }
            });
        }
    }

    $('.content__bottom .update-cart').on('click', function(e) {
        $( ".cart__submit-controls input[name='update']" ).trigger( "click" );
    });
    // Toggle mini-cart
    $('.site-header__icon.site-header__cart:not(.disabled)').on('click', function(e) {
        if($('.mini-cart-wrapper').hasClass('show')){
            $('body').removeClass('open-minicart');
            $('html').removeClass('open-minicart');
            $('.mini-cart-wrapper').removeClass('show');
        }else{
            $('body').addClass('open-minicart');
            $('html').addClass('open-minicart');
            $('.mini-cart-wrapper').toggleClass('show');
        }
    });

    // Colse minicart
    $(document).on('click', '.close-minicart', function(e) {
        $('.mini-cart-wrapper').removeClass('show');
        $('body').removeClass('open-minicart');
        $('html').removeClass('open-minicart');
    });

    // Click outside clode minicart
    $(document).on( "click", '.bg-minicart-close', function(e) {
        $('.mini-cart-wrapper').removeClass('show');
        $('body').removeClass('open-minicart');
        $('html').removeClass('open-minicart');
    });

    // Remove minicart
    $(document).on('click', '.cart-details .remove-item .delete', function() {
        var id = $(this).data('cart-item');
        var labelTitle = $(this).data('label');

        if (labelTitle == 'Gift-wrapping'){
            console.log('active');
        }
        if (id) {
            $('.mini-cart-content #mincart-loading').show();
            $.ajax({
                method: "POST",
                url: "/cart/update.js",
                data: "updates["+ id +"]=0",
                dataType: "json",
                success: function(response) {
                    //console.log();
                    if(response['item_count'] == 0){
                        $('#close-cart').trigger('click');
                    }
                    refreshMiniCart();
                },
                error: function(XMLHttpRequest, textStatus) {
                    $('.mini-cart-content #mincart-loading').hide();
                    handleError(XMLHttpRequest);
                }
            });
        }
    });

    // Check Discount Code
    $('.apply-discount').on('click', function(e) {
        e.preventDefault();
        let valInput = $('input[name="discount"]').val();
        if(valInput == '') {
            $('.discount').find('label').addClass('error-label');
            $('input[name="discount"]').addClass('error');
            $('.box-discount').addClass('error');
        }
    });

    //  Quantity Item Minicart
    // $('.product-form__input.product-form__input--quantity').keyup(debounce(function(){
    //     let that = $(this);
    //     let item_id = $(this).closest('.product-form-item').data('id');
    //     let qty = parseInt(that.val());

    //     console.log(qty);

    //     if(qty < 0) {
    //         qty = 1;
    //         updateMinicart(item_id, qty);
    //     } else {
    //         updateMinicart(item_id, qty);
    //     }
    // },300));

    // $(document).on('keyup', '.product-form__input.product-form__input--quantity', function() {
    //     let that = $(this);

    //     setTimeout(function(){
    //         let item_id = $(this).closest('.product-form-item').data('id');
    //         let qty = parseInt(that.val());
    //         console.log(qty);
    //     }, 3000);
    // });

    $(document).on('change', '.product-form__input.product-form__input--quantity', function() {
        let that = $(this);
        let item_id = $(this).closest('.product-form-item').data('id');
        let qty = parseInt(that.val());
        if(qty < 0) {
            qty = 1;
            updateMinicart(item_id, qty);
        } else {
            updateMinicart(item_id, qty);
        }
    });







    // $(document).on('change', '.template-cart .product-form__input--quantity', function() {
    //     let that = $(this);
    //     let item_id = $(this).closest('.product-form-item').data('id');
    //     let qty = parseInt(that.val());

    //     console.log(item_id);
    //     console.log(qty);
    //     return false;


    //     if(qty < 0) {
    //         qty = 1;
    //         updateMinicart(item_id, qty);
    //     } else {
    //         updateMinicart(item_id, qty);
    //     }
    // });


    // Update Minicart
    function updateMinicart(product_id, product_quantity) {
        var id = product_id;
        var qty = product_quantity;
        $.ajax({
            method: "POST",
            url: "/cart/update.js",
            data: "updates["+ id +"]=" + qty,
            dataType: "json",
            success: function(response) {
                $('.mini-cart-content #mincart-loading').show();
                refreshMiniCart();
            },
            error: function(XMLHttpRequest, textStatus) {
            $('.mini-cart-content #mincart-loading').hide();
            handleError(XMLHttpRequest);
            }
        });
    }

    // Handle mobile checkout
    $('.checkout-mobile').on('click', function() {
        $('.cart__submit-controls .cart__submit').trigger('click');
    });

    $('input[name="discount"]').on('keyup', function(e) {
        let that = $(this);
        if(that.val() != '') {
            $('.discount').find('label:not(.title)').removeClass('error-label');
            that.removeClass('error');
            $('.box-discount').removeClass('error');
            $('.apply-discount').addClass('pass');
        }else {
            $('.discount').find('label').addClass('error-label');
            $('input[name="discount"]').addClass('error');
            $('.box-discount').addClass('error');
        }
    });

    //

    $('.mini-cart-wrapper .list-items').scroll(function() {

        if($(this).scrollTop() == 0) {
            $('.minicart-actions').removeClass('remove-before');
        }else {
            $('.minicart-actions').addClass('remove-before');
        }


        // if($(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight) {
        //     $('.minicart-actions').addClass('remove-before');
        // } else {
        //     $('.minicart-actions').removeClass('remove-before');
        // }
    });

    // Handle quantity on minicart
    $(document).on('click', '.mini-cart-wrapper .product-form-item .product-plus', function() {
        var $inputQty = $(this).closest('.product-form-item').find('.product-form__input--quantity').first();
        var qty = parseInt($inputQty.val());

        $(this).prop('disabled', true);
        $(this).addClass('disabled');

        $inputQty.val(qty).trigger('change');
    });

    $(document).on('click', '.mini-cart-wrapper .product-form-item .product-minus', function() {
        var $inputQty = $(this).closest('.product-form-item').find('.product-form__input--quantity').first();
        var qty = parseInt($inputQty.val());

        $(this).prop('disabled', true);
        $(this).addClass('disabled');

        $inputQty.val(qty).trigger('change');
    });

    // Handle quantity on page cart
    $(document).on('click', '.template-cart .product-form-item .plus', function(e) {
        if ($(window).width() > 767) {
            var $inputQty = $(this).closest('.product-form-item').find('.product-form__input--quantity[data-role="product-quantity-desktop"]');
        }else {
            var $inputQty = $(this).closest('.product-form-item').find('.product-form__input--quantity[data-role="product-quantity-mobile"]');
        }

        var qty = parseInt($inputQty.val());
        qty = qty + 1;

        $inputQty.val(qty).trigger('change');
    });

    $(document).on('click', '.template-cart .cart__qty .minus', function() {
        if ($(window).width() > 767) {
            var $inputQty = $(this).closest('.product-form-item').find('.product-form__input--quantity[data-role="product-quantity-desktop"]');
        }else {
            var $inputQty = $(this).closest('.product-form-item').find('.product-form__input--quantity[data-role="product-quantity-mobile"]');
        }

        var qty = parseInt($inputQty.val());
        qty = qty - 1;

        $inputQty.val(qty).trigger('change');
    });


    setTimeout(function(){
        $('.fh__products_slide').owlCarousel({
            margin: 30,
            loop: true,
            autoWidth: true,
            items: 6,
            responsive:{
                0:{
                    margin: 12,
                    items: 5
                },
                768:{
                    margin: 30,
                    items: 6
                }
            }
        });
        $('.fh__products-collection').owlCarousel({
            margin: 30,
            loop: false,
            items: 4,
            nav: false,
            dots: false,
            navText: ["<i class='far fa-chevron-left'></i>", "<i class='far fa-chevron-right'></i>"],
            responsive:{
                0:{
                    margin: 12,
                    items: 2,
                    nav: true,
                    dots: true
                },
                768:{
                    margin: 30
                }
            }
        });

    }, 1000);


    // Set owl catalogue detail
    function getUrlParameter(sParam) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
        return false;
    };

    function initCatalogueDetailOwl() {
        // get start slide index
        let startPosition = getUrlParameter('slideIndex');
        $('.fh-text-columns-with-catalogue-detail .owl-carousel').owlCarousel({
            margin: 0,
            loop: false,
            items: 2,
            slideBy: 2,
            nav: true,
            dots: false,
            loop: true,
            navText: ["<i class='far fa-chevron-left'></i>", "<i class='far fa-chevron-right'></i>"],
            responsive:{
                0:{
                    items: 1
                },
                640:{
                    items: 1
                },
                768:{
                    items: 2
                },
                1000:{
                    items: 2
                }
            },
            startPosition: startPosition ? startPosition : 0
        });
    }
    if ($('body').hasClass('page-catalogue-detail')) {
        initCatalogueDetailOwl();
    }

    // MEGA MENU
    // Mega Menu
    $('.mega-menu-container .mega-menu').clone().appendTo('.mega-menu-drop');
    $(".mega-menu-drop").addClass("is-closed");
    var hoverTimer;
    $('.menu-drop-down>a').on('mouseover', function (e) {
    e.preventDefault();
    clearTimeout(hoverTimer);
        $('.site-nav li a').removeClass("active_link");
        $(".site-nav").removeClass("move-border");
    var element = $(this);
    if (element.hasClass('dropdown_link')) {
    $('.dropdown_container').removeClass('active_link');
        $('.site-nav li a').removeClass("active_link");
        element.addClass('active_link');
        if (element.hasClass('active_link')) {
            hoverTimer = setTimeout(function(){
                $(".mega-menu-drop").addClass("is-open");
                $(".main-menu").addClass("nav_open");
                $("body").addClass("mega_open");
                $(".mega-menu-drop").removeClass("is-closed");
                $('.dropdown_container').removeClass("active");
                element.parents('.main-menu').find('[data-dropdown="' + element.data('dropdown-rel') + '"]').addClass("active");
            }, 0);
        }
    }
    else{
        clearTimeout(hoverTimer);
            $('.site-nav li a').removeClass("active_link");
            $(".mega-menu-drop").removeClass("is-open");
            $(".main-menu").removeClass("nav_open");
            $(".mega-menu-drop").addClass("is-closed");
            $("body").removeClass("mega_open");
            $('.site-nav li').removeClass("active");
            $('.dropdown_container').removeClass("active");
            $(".site-nav").removeClass("move-border");
    }
    });

    $('.mega-menu-drop').on('mouseleave', function (e) {
        $('.site-nav li a').removeClass("active_link");
        $('.site-nav li').removeClass("active");
        $('.mega-menu-drop').removeClass("is-open");
        $(".main-menu").removeClass("nav_open");
        $(".mega-menu-drop").addClass("is-closed");
        $('.dropdown_container').removeClass("active");
        $(".site-nav").removeClass("move-border");
        $("body").removeClass("mega_open");
    });

    $(document).on('click', function(e) {
        var container = $('.main-menu');
        var container2 = $('.mega-menu-drop');
        if (!container.is(e.target) && container.has(e.target).length === 0 && !container2.is(e.target) && container2.has(e.target).length === 0) {
            $('.site-nav li a').removeClass("active_link");
            $('.site-nav li').removeClass("active");
            $('.mega-menu-drop').removeClass("is-open");
            $(".main-menu").removeClass("nav_open");
            $(".mega-menu-drop").addClass("is-closed");
            $('.dropdown_container').removeClass("active");
            $(".site-nav").removeClass("move-border");
            $("body").removeClass("mega_open");
        }
    });

    jQuery(document).on('click','.toggle-menu',function(e){
        e.preventDefault();
        jQuery('.mobile-nav-container').addClass('open_megamenu');
        jQuery('body').addClass('menu_is_open');
    });
    jQuery(document).on('click','.js-toggle-submenu',function(e){
        e.preventDefault();
        jQuery(this).next().addClass('open_mega_sub');
    });
    jQuery(document).on('click','.mobile-nav__return-btn',function(e){
        e.preventDefault();
        jQuery(this).closest('.mobile-nav__subdropdown').removeClass('open_mega_sub');
    });
    jQuery(document).on('click','.bg-close , .close-menu',function(e){
        e.preventDefault();
        jQuery('.mobile-nav-container').removeClass('open_megamenu');
        jQuery('body').removeClass('menu_is_open');
        jQuery('.mobile-nav__subdropdown').removeClass('open_mega_sub');
    });

    // MENU FOOTER
    var $window = $(window);
    var windowsize = $window.width();

    if (windowsize < 769) {
        $('.item-sub-menu .headding').on('click', function(){
            if($(this).parents('.item-sub-menu').hasClass('open')){
                $(this).parents('.item-sub-menu').find('.site-nav-sub').slideUp();
                $(this).parents('.item-sub-menu').removeClass('open');
            }
            else{
                $('.site-nav-sub').slideUp();
                $('.item-sub-menu').removeClass('open');
                $(this).parents('.item-sub-menu').find('.site-nav-sub').slideDown();
                $(this).parents('.item-sub-menu').addClass('open');
            }
        });
    }

    setTimeout(function () {
        $('.fh__products').owlCarousel({
            margin:30,
            loop:false,
            dots:false,
            nav: false,
            navText: ["<i class='far fa-chevron-left'></i>", "<i class='far fa-chevron-right'></i>"],
            items:6,
            responsive:{
                0:{
                    items:2,
                    margin: 12,
                    dots: false,
                    nav: true,
                },
                768:{
                    margin:15,
                    items:6
                },
                991:{
                    margin:20,
                    items:6
                }
            }
        });

        $('.slide__button').owlCarousel({
            margin:30,
            loop:false,
            dots:false,
            nav: false,
            autoWidth: true,
            items:4,
            responsive:{
                0:{
                    items:2,
                    autoWidth: false,
                    margin: 12
                },
                360:{
                    items:2,
                    autoWidth: false,
                    margin: 18
                },
                768:{
                    dots:false,
                    autoWidth: false,
                    items:4,
                    nav: false
                },
                1024:{
                    dots:false,
                    autoWidth: true,
                    items:4,
                    nav: false
                }
            }
        });
        $('.banner-navigation').owlCarousel({
            margin:18,
            loop:false,
            dots:false,
            nav: false,
            items:2,
            responsive:{
                0:{
                    items:1,
                    margin: 0
                },
                769:{
                    margin:18,
                    items:2
                }
            }
        });
    }, 250)
    //Product page

    $('.MagicToolboxSelectorsContainer').slick({
        slidesToShow: 6,
        verticalSwiping: true,
        vertical: true,
        autoplay: false,
        centerMode: true,
        infinite: false,
        arrows: true
       });

    // Recommendations product slider
    var $carousel = $('.template-product .product-recommendations__inner .grid--view-items');

    $carousel.owlCarousel({
        loop: false,
        margin: 25,
        nav: false,
        dots: false,
//scrollbarType: "scroll",
        responsive:{
            0:{
                items:2,
                dots: false,
                margin: 12
            },
            700:{
                dots: false,
                items:3
            },
            768: {
                dots: false,
                margin: 16
            },
            880: {
                dots: false,
                margin: 32
            },
            1150:{
                dots: false,
                items:4
            }
        }
    });

    var $scrollbar = $('<div class="owl-scrollbar"><div class="owl-scroll-handle"></div></div>');
    $carousel.append($scrollbar);

    var isDragging = false;
    var initialX;

    var updateScrollbar = function () {
        var totalItems = $carousel.find('.owl-item').length;

        if (totalItems <= 4) {
            $scrollbar.addClass('scroll_mobile');
        } else {
            $scrollbar.removeClass('scroll_mobile');
        }
    };

    updateScrollbar(); // Initial check

    $scrollbar.on('mousedown touchstart', function (e) {
        isDragging = true;
        initialX = e.pageX || e.originalEvent.touches[0].pageX;
    });

    $(document).on('mousemove touchmove', function (e) {
        if (isDragging) {
            var currentX = e.pageX || e.originalEvent.touches[0].pageX;
            var deltaX = currentX - initialX;

            var handleWidth = $scrollbar.find('.owl-scroll-handle').width();
            var scrollbarWidth = $scrollbar.width();
            var carouselWidth = $carousel.width();
            var maxTranslateX = scrollbarWidth - handleWidth;

            var handleLeft = parseFloat($scrollbar.find('.owl-scroll-handle').css('left')) + deltaX;
            handleLeft = Math.max(0, Math.min(handleLeft, maxTranslateX));

            var percentage = handleLeft / maxTranslateX;
            var newPosition = Math.round((carouselWidth - scrollbarWidth) * percentage);
            $carousel.trigger('to.owl.carousel', [newPosition, 300, true]);

            $scrollbar.find('.owl-scroll-handle').css('left', handleLeft + 'px');

            initialX = currentX;
        }
    });

    $(document).on('mouseup touchend', function () {
        isDragging = false;
    });

function appendVariantCount() {
  const variantWrappers = document.querySelectorAll('.variant_wrapper');
  variantWrappers.forEach(variantWrapper => {
      const variantItems = variantWrapper.querySelectorAll('.variant-item');
      const variantCount = variantItems.length;
      if( variantCount  > 0 ){
      setTimeout(function(){
        const countElement = document.createElement('div');
        countElement.classList.add('variant-count-num');
        if( variantCount  <= 1 ){
            countElement.textContent = `${variantCount} Colour`;
        } else {
            countElement.textContent = `${variantCount} Colours`;
        }
        variantWrapper.appendChild(countElement);
      },100);
      }
      if( variantCount  > 3 ){
      const mobileVarShowCount = variantCount - 3;

      const countElementM = document.createElement('div');
      countElementM.classList.add('variant-count-total');
      countElementM.textContent = `+${mobileVarShowCount}`;
      variantWrapper.appendChild(countElementM);
      }
      if( variantCount  == 0 ){
          variantWrapper.classList.add('hidden');
      }
  });
}

appendVariantCount();

    $(".product-form-product-template .product-form__controls-group .product-form__item").find(".item_option").each(function(){
        $(this).click(function(e) {
            let selectOption = $(this).parent().siblings('.single-option-selector');
            let selectId = '#' + selectOption.attr('id');
            let value = $(this).data('value');
            $(selectOption).val(value);
            $(this).closest('.list_option').find(".item_option").removeClass('active');
            $(this).addClass('active');
            realSelectDom = document.querySelector(selectId);
            realSelectDom.dispatchEvent(new Event('change'));
            $(this).closest(".product-form__item").find(".option-value").text(value);
        });
    });

    // Load option on catalogue product page
    function selectonLoad() {
        $('.fh-product__form-option .list_option .item_option').each(function(){
            var productOptionsWrapper = $(this).closest('.fh-product__form-option');
            let wrapper = $(this).closest('.fh-product__form-option.product-form-product-template');
            if ($(this).closest('.list_option').attr('data-for') == 'SingleOptionSelector-0') {
                var currentOption = $(this).text().trim();
                productOptionsWrapper.find('.product-form__variants').first().find('option').each(function() {
                    var arr =  $(this).text().trim().split(' / ');
                    // var lastIndex = arr.length - 1;
                    // var lastOption = arr[lastIndex].trim();
                    var firstOption = arr[0].trim();
                    var data_qty = $(this).data('qty');
                    if (firstOption == currentOption) {
                        if (data_qty <= 0) {
                            var name = firstOption.toLowerCase().replace('/','-');
                            wrapper.find(".product-form__controls-group .product-form__item.variant-Size").find(".item_option.size-"+name).addClass('disabled');
                        }
                    }
                });
            }
        });

        $('.fh-product__form-option .product-form__item.variant-Size').each(function () {
            if ($(this).find('.list_option[data-option="size"] .item_option.active').length == 0) {
                $(this).find('label .option-value').text('');
            }
        });
        $('.fh-product__form-option .list_option[data-option="size"] .item_option.active').trigger('click');
    }
    // Select optione in catalogue product page
    function selectOptions(){
        $('.fh-product__form-option .list_option .item_option').click(function() {
            var productOptionsWrapper = $(this).closest('.fh-product__form-option');
            if ($(this).closest('.list_option').attr('data-for') == 'SingleOptionSelector-0') {
                var currentOption = $(this).text();
                colorOption = currentOption;
                productOptionsWrapper.find('.list_option[data-for="SingleOptionSelector-1"] .item_option').removeClass('disabled');
                productOptionsWrapper.find('.product-form__variants').first().find('option').each(function() {
                    var arr =  $(this).text().trim().split(' / ');
                    var lastIndex = arr.length - 1;
                    var firstOption = arr[0];
                    var disabled = $(this).attr('disabled');
                    if (firstOption == currentOption) {
                        var lastOption = arr[lastIndex];
                        productOptionsWrapper.find('.list_option[data-for="SingleOptionSelector-1"] .item_option').each(function() {
                        if ($(this).text() == lastOption) {
                        $(this).addClass(disabled);
                        }
                    });
                    }
                });
            }
            var optionValue = $(this).data('value');
            //var optionText = $(this).text();
            $(this).closest('.selector-wrapper').find('.option-value').text(optionValue);
            $(this).siblings().removeClass('active');
            $(this).addClass('active');
            if($(this).hasClass('disabled')){
                productOptionsWrapper.find('.product-form__cart-submit').attr('aria-disabled', true).prop('disabled', true);
                productOptionsWrapper.find('.product-form__cart-submit span[data-add-to-cart-text]').text('Sold out');
            }else{
                productOptionsWrapper.find('.product-form__cart-submit').attr('aria-disabled', false).prop('disabled', false);
                productOptionsWrapper.find('.product-form__cart-submit span[data-add-to-cart-text]').text('Add to bag');
            }
            var masterValue = '';
            var colorOption = productOptionsWrapper.find('label[for="SingleOptionSelector-0"] .option-value').text();
            var sizeOption = productOptionsWrapper.find('label[for="SingleOptionSelector-1"] .option-value').text();
            masterValue = colorOption + " / " + sizeOption;
            productOptionsWrapper.find('.product-form__variants').first().find('option').each(function() {
                var option = $(this);
                if (option.text().trim() == masterValue) {
                    option.parent().val(option.val()).change();
                    var option_id = option.data('id');
                    var price = option.data('price');
                    productOptionsWrapper.find('.variant_id').text(option_id);
                    // if (price) {
                    //     option.closest('.productinfo-product').find('.product__price > .money:first-child span').text(Shopify.formatMoney(price, theme.moneyFormat).replace(/((\,00)|(\.00))$/g, ''));
                    // }
                }
            });
        });
    }
    selectOptions();
    selectonLoad();

    // Add to cart in catalog page
    $(document).on('click', '.btn-add-to-cart-product-page', function(e) {
        e.preventDefault();
        var btn = $(this);
        var form = btn.closest('.fh-product__form-option');
        var vId = form.find('.variant_id').text();
        //console.log(vId);
        var qty = form.find('.product-form__select').val();
        //console.log(qty);
        if (vId && qty) {
            btn.attr('aria-disabled', 'true');
            btn.find('span[data-add-to-cart-text]').addClass('hide');
            btn.find('span[data-loader]').removeClass('hide');
            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: 'quantity='+ qty +'&id=' + vId,
                dataType: 'json',
                xhrFields: {
                    withCredentials: true
                },
                success: function(lineitem) {
                    btn.closest('.fh-product__form-option').find('.product-form__error-message-wrapper').removeClass('show');
                    btn.attr('aria-disabled', '');
                    btn.find('span[data-add-to-cart-text]').removeClass('hide');
                    btn.find('span[data-loader]').addClass('hide');
                    refreshMiniCart(lineitem, qty);
                    jQuery('.site-header__cart').trigger('click');
                },
                error: function(XMLHttpRequest, textStatus) {
                    var data = eval('(' + XMLHttpRequest.responseText + ')');
                    var errorMessage = '';
                    if (!!data.message) {
                        errorMessage = data.description
                    } else {
                        errorMessage = 'Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.';
                    }
                    btn.attr('aria-disabled', '');
                    btn.find('span[data-add-to-cart-text]').removeClass('hide');
                    btn.find('span[data-loader]').addClass('hide');
                    btn.closest('.fh-product__form-option').find('.product-form__error-message-wrapper').addClass('show');
                    btn.closest('.fh-product__form-option').find('.product-form__error-message').text(errorMessage);
                }
            });
        }
    });

    // END

    $(".show-size-chart").click(function(e){
        e.preventDefault();
        // var size_guide = $(this).data('size-chart');
        // var target = $(this).closest('.product-form__controls-group').find('.size-chart-container .size-chart');
        // if(size_guide){
        //     $.ajax({
        //         method: "GET",
        //         url: size_guide,
        //         xhrFields: {
        //             withCredentials: true
        //         },
        //         dataType: 'json',
        //         success: function(response) {
        //             //console.log(response.page.body_html);
        //             var data = response.page.body_html;
        //             target.html(data);
        //         }
        //         });
        // }

        $(this).closest('.product-form__controls-group').find(".size-chart-popup").addClass("show");
        $("body").addClass("show-size-chart");
        $("html").css("overflow", "hidden");
    });
    $(".close-size-chart").click(function(e) {
        e.preventDefault();
        $(".size-chart-popup").removeClass("show");
        $("body").removeClass("show-size-chart");
        $("html").css("overflow", "auto");
    })

    $(".bg-size-chart").click(function(e) {
        e.preventDefault();
        $(".size-chart-popup").removeClass("show");
        $("body").removeClass("show-size-chart");
        $("html").css("overflow", "auto");
    })

    // Sticky
    $('.cd-auto-hide-header').addClass('active');
    $(window).scroll(function (event) {
        var st = $(this).scrollTop();
        if(st == 0){
            $('.cd-auto-hide-header').addClass('active');
            $('.cd-auto-hide-header').removeClass('scroll');
            $('.cd-auto-hide-header').removeClass('scroll_active');
            $('body').removeClass('search-scroll');
            $('.navigation-container').removeClass("navigation-scroll");
        }else{
            $('.cd-auto-hide-header').removeClass('active');
            $('.cd-auto-hide-header').addClass('scroll_active');
            $('body').addClass('search-scroll');
        }
    });
    var mainHeader = $('.cd-auto-hide-header'),
		secondaryNavigation = $('.navigation-container'),
		//this applies only if secondary nav is below intro section
		belowNavHeroContent = $('.sub-nav-hero'),
		headerHeight = mainHeader.height();

	//set scrolling variables
	var scrolling = false,
		previousTop = 0,
		currentTop = 0,
		scrollDelta = 10,
		scrollOffset = 150;

	$(window).on('scroll', function(){
		if( !scrolling ) {
			scrolling = true;
			(!window.requestAnimationFrame)
				? setTimeout(autoHideHeader, 250)
				: requestAnimationFrame(autoHideHeader);
		}
	});

	$(window).on('resize', function(){
		headerHeight = mainHeader.height();
	});

	function autoHideHeader() {
		var currentTop = $(window).scrollTop();

		( belowNavHeroContent.length > 0 )
			? checkStickyNavigation(currentTop) // secondary navigation below intro
			: checkSimpleNavigation(currentTop);

	   	previousTop = currentTop;
		scrolling = false;
	}

	function checkSimpleNavigation(currentTop) {
		//there's no secondary nav or secondary nav is below primary nav
	    if (previousTop - currentTop > scrollDelta) {
	    	//if scrolling up...
	    	mainHeader.removeClass('is-hidden');
	    } else if( currentTop - previousTop > scrollDelta && currentTop > scrollOffset) {
	    	//if scrolling down...
	    	mainHeader.addClass('is-hidden');
            $('.navigation-container').addClass("navigation-scroll");
            $('.cd-auto-hide-header').addClass('scroll');
            $('.site-nav li a').removeClass("active_link");
            $('.site-nav li').removeClass("active");
            $('.mega-menu-drop').removeClass("is-open");
            $(".main-menu").removeClass("nav_open");
            $(".mega-menu-drop").addClass("is-closed");
            $('.dropdown_container').removeClass("active");
            $(".site-nav").removeClass("move-border");
            $("body").removeClass("mega_open");
	    }
	}

	function checkStickyNavigation(currentTop) {
		//secondary nav below intro section - sticky secondary nav
		var secondaryNavOffsetTop = belowNavHeroContent.offset().top - secondaryNavigation.height() - mainHeader.height();

		if (previousTop >= currentTop ) {
	    	//if scrolling up...
	    	if( currentTop < secondaryNavOffsetTop ) {
	    		//secondary nav is not fixed
	    		mainHeader.removeClass('is-hidden');
	    		secondaryNavigation.removeClass('fixed slide-up');
	    		belowNavHeroContent.removeClass('secondary-nav-fixed');
	    	} else if( previousTop - currentTop > scrollDelta ) {
	    		//secondary nav is fixed
	    		mainHeader.removeClass('is-hidden');
	    		secondaryNavigation.removeClass('slide-up').addClass('fixed');
	    		belowNavHeroContent.addClass('secondary-nav-fixed');
	    	}
	    } else {
	    	//if scrolling down...
	 	  	if( currentTop > secondaryNavOffsetTop + scrollOffset ) {
	 	  		//hide primary nav
	    		mainHeader.addClass('is-hidden');
                $('.cd-auto-hide-header').addClass('scroll');
                $('.navigation-container').addClass("navigation-scroll");
	    		secondaryNavigation.addClass('fixed slide-up');
	    		belowNavHeroContent.addClass('secondary-nav-fixed');
	    	} else if( currentTop > secondaryNavOffsetTop ) {
	    		//once the secondary nav is fixed, do not hide primary nav if you haven't scrolled more than scrollOffset
                mainHeader.addClass('is-open');
	    		mainHeader.removeClass('is-hidden');
	    		secondaryNavigation.addClass('fixed').removeClass('slide-up');
	    		belowNavHeroContent.addClass('secondary-nav-fixed');
	    	}
	    }
	}

    // Form GiftCard Balance
    $('.page-giftcard-balance #code').on('change keydown', function() {
        let that = $(this);
        let valueCode = that.val();
        if (valueCode !== '') {
            $('.page-giftcard-balance .btn-submit').removeAttr('disabled');
        } else {
            $('.page-giftcard-balance .btn-submit').attr('disabled', 'disabled');
            $('#error-for-gift_code').css('display', 'none');
        }
    });

    $('.page-giftcard-balance .btn-submit').on('click', function(e) {
        e.preventDefault();
        let that = $(this);
        that.addClass('loading');
        var dataPost = {
            serial: String($('#form_giftcard_balance #code').val())
        }

        $.ajax({
            url: 'https://xtt4lp3rr1.execute-api.ap-southeast-2.amazonaws.com/dev/giftcard/balance',
            contentType: 'application/json',
            dataType: 'json',
            data: JSON.stringify(dataPost),
            method: 'POST',
            beforeSend: function() {
                $('.page-giftcard-balance .icon-svg--spinner-button').addClass('spinner-inf');
                $('.page-giftcard-balance .btn-submit').attr('disabled', 'disabled');
                $('.page-giftcard-balance .btn-submit .btn-text').css('opacity', '0');
            },
            complete: function() {
                that.removeClass('loading');
                $('.page-giftcard-balance .icon-svg--spinner-button').removeClass('spinner-inf');
                $('.page-giftcard-balance .btn-submit').attr('disabled', 'disabled');
                $('.page-giftcard-balance .btn-submit .btn-text').css('opacity', '1');
            },
            success: function(data,textStatus,xhr) {
                if (data && data.balance) {
                    let expiryDate = data.expiryDate.replaceAll('-', '/');
                    that.removeClass('loading');
                    $('#error-for-gift_code').text('Gift voucher serial number is valid');
                    $('#gift_code_balance').text('Balance: $' + data.balance);
                    $('#gift_code_expiry').text('Expiry: ' + expiryDate);

                    $('#error-for-gift_code, #gift_code_balance, #gift_code_expiry').css({
                        'display': 'block',
                        'color': 'green'
                    });
                }
            },
            error: function(data) {
                $('#error-for-gift_code').text(data.responseJSON.message);
                $('#error-for-gift_code, #gift_code_balance, #gift_code_expiry').css({
                    'display': 'block',
                    'color': 'red'
                });
                $('#gift_code_balance, #gift_code_expiry').css({
                    'display': 'none'
                });
            }
        });
        return false;
    });


    // Custom catalogue return history page & slide
    $('[data-action="view-catalogue-detail"]').on('click', function(e) {
        e.preventDefault;
        let urlRedirect = $(this).attr('href');
        let currentUrl = window.location.origin + window.location.pathname;
        let slideIndex = $(this).data('slide-index');
        sessionStorage.setItem('catalogue_url', currentUrl);
        sessionStorage.setItem('catalogue_slideIndex', slideIndex);

        // redirect to catalogue detail
        window.localStorage.href = urlRedirect;
    });

    $('[data-action="return-history"]').on('click', function(e) {
        e.preventDefault;
        let urlReturn = sessionStorage.getItem('catalogue_url');
        if (urlReturn !== 'underfine' || urlReturn != '') {
            let slideIndex = sessionStorage.getItem('catalogue_slideIndex');
            // clear session storage
            sessionStorage.removeItem('catalogue_url');
            sessionStorage.removeItem('catalogue_slideIndex');
            // return catalogue page with slide index
            if (urlReturn.search('/?/') !== -1) {
                window.location.href = urlReturn + '?slideIndex=' + slideIndex;
            } else {
                window.location.href = urlReturn + '&slideIndex=' + slideIndex;
            }
        } else {
            // return to history -1 url
            history.back();
        }
        return false;
    });

    //Collection SEO Text accordion
    $('.accordion__title').on('click', function(e) {
        $(this).toggleClass('active').next('.accordion__content').slideToggle();
    });

    //Collection Readmore
    $('.cta-readMore').on('click', function(e) {
        e.preventDefault();
        $(this).closest('.header-content-wrapper').addClass('readMore-active');
    });

    $('.cta-readLess').on('click', function(e) {
        e.preventDefault();
        $(this).closest('.header-content-wrapper').removeClass('readMore-active');
    });
});
